var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuterLineLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 36,
    viewBox: "0 0 204 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outer-line-left",
    d: "M17.4983 0.550388C7.91001 0.550389 0.137179 8.32322 0.13718 17.9115C0.137181 27.4998 7.91002 35.2726 17.4983 35.2726L17.4983 0.550388ZM17.4983 17.9115L17.4983 35.2726L203.609 35.2726L203.609 17.9115L203.609 0.550372L17.4983 0.550388L17.4983 17.9115Z",
    fill: "#97E9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterLineLeft);
export default __webpack_public_path__ + "static/media/outer-line-left.04d45c58d539b525dd6ca7f4230c5b89.svg";
export { ForwardRef as ReactComponent };